import { createSelector } from '@reduxjs/toolkit'

import { selectDownload } from './selectDownload'

export const selectDownloadStatus = createSelector(selectDownload, (download) => download.status)
